<template>
  <!-- 国内旅行予定登録 -->
  <div id="AppDomesticTravel" :status="status" :type="type" style="width: 100%;display:inline-block;">
    <!-- 上部余白 -->
    <div style="height: 10px;" />
    <div style="margin-left:2%; margin-Right: 2%;">
      <div class="columns">
        <div class="column">
          <label
            class="searchTitle label"
            v-if="type === 'edit'&&!this.editFlg&&status!='4'&&status!='3'"
          >旅程編集</label>
          <label
            class="searchTitle label"
            v-else-if="type === 'new'&&!this.editFlg&&status!='4'&&status!='3'"
          >旅程登録</label>
          <label class="searchTitle label" v-else-if="this.editFlg||status=='4'||status=='3'">旅程参照</label>
          <label class="searchTitle label" v-else>旅程登録(複写)</label>
        </div>
      </div>
      <!-- 詳細表示 -->
      <div style="detailArea" :data="data">
        <div v-if="!editFlg && status!='4' && status!='3'">
          <div style="height:10px;"></div>
          <table style="width: 100%;" class="table">
            <tr v-if="type === 'edit'">
              <td style="border-bottom: solid 0px;" colspan="2">
                <div style="text-align:right;">
                  <b-button
                    v-on:click="refDetail(data)"
                    class="button"
                    type="is-primary"
                    icon-left="alert-circle"
                    native-type="button"
                  >患者情報閲覧</b-button>
                  <b-button
                    v-on:click="goToPatientSearch(data)"
                    class="button"
                    type="is-primary"
                    icon-left="alert-circle"
                    native-type="button"
                  >患者情報閲覧（検索）</b-button>
                </div>
              </td>
            </tr>

            <tr>
              <th style="border-bottom: solid 1px; width: 200px;">旅行期間</th>
              <td style="border-bottom: solid 1px;" colspan="2">
                <b-field>
                  <b-field
                    label
                    labelPosition="on-border"
                    :type="{'is-danger':errors.has('startDate')}"
                    :message="errors.first('startDate')"
                  >
                    <b-datepicker
                      name="startDate"
                      v-model="startDate"
                      placeholder="開始年月日"
                      data-vv-as="開始年月日"
                      data-vv-validate-on="input"
                      v-validate="'required'"
                      icon="calendar-today"
                      :month-names="['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']"
                      :day-names="['日','月','火','水','木','金','土']"
                    ></b-datepicker>
                  </b-field>
                  <b-field
                    label
                    labelPosition="on-border"
                    :type="{'is-danger':errors.has('endDate')}"
                    :message="errors.first('endDate')"
                  >
                    <b-datepicker
                      name="endDate"
                      v-model="endDate"
                      placeholder="終了年月日"
                      data-vv-as="終了年月日"
                      data-vv-validate-on="input"
                      v-validate="'required|endDateCheck'"
                      icon="calendar-today"
                      :month-names="['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']"
                      :day-names="['日','月','火','水','木','金','土']"
                    ></b-datepicker>
                  </b-field>
                </b-field>
              </td>
            </tr>
            <tr>
              <th style="border-bottom: solid 1px; width: 200px;">患者名（患者名カナ）</th>
              <td style="border-bottom: solid 1px;" colspan="2">
                <b-field
                  :type="{'is-danger':errors.has('patientName')}"
                  :message="errors.first('patientName')"
                >
                  <b-input
                    :readonly="true"
                    v-model="data.patientName"
                    name="patientName"
                    data-vv-as="患者名"
                    v-validate="'required'"
                  ></b-input>
                  <b-button
                    style="float:right"
                    class="button is-primary has-text-centered"
                    icon-left="account-switch"
                    native-type="button"
                    v-on:click="changePatient"
                  >患者選択</b-button>
                  <div style="margin-left: 10px; margin-top: 10px;">
                    <template v-if="data.patientNameKana">（{{data.patientNameKana}}）</template>
                  </div>
                  <b-modal :active.sync="isSelectPatientActive" has-modal-card full-screen>
                    <selectPatient-form v-on:set-patient="setPatientName"></selectPatient-form>
                  </b-modal>
                </b-field>
              </td>
            </tr>
            <tr>
              <th style="border-bottom: solid 1px; width: 200px;">連絡先</th>
              <td style="border-bottom: solid 1px;" colspan="2">
                <b-field
                  :type="{'is-danger':errors.has('patientPhone')}"
                  :message="errors.first('patientPhone')"
                >
                  <b-input
                    v-model="data.patientPhone"
                    name="patientPhone"
                    data-vv-as="患者連絡先"
                    v-validate="'required|max:20'"
                    maxlength="20"
                  ></b-input>
                </b-field>
              </td>
            </tr>
            <tr>
              <th style="border-bottom: solid 1px; width: 200px;">同行者名</th>
              <td style="border-bottom: solid 1px;" colspan="2">
                <b-field
                  :type="{'is-danger':errors.has('companionName')}"
                  :message="errors.first('companionName')"
                >
                  <b-input
                    v-model="data.companionName"
                    name="companionName"
                    data-vv-as="同行者名"
                    v-validate="'max:50'"
                    maxlength="50"
                  ></b-input>
                </b-field>
              </td>
            </tr>
            <tr>
              <th style="border-bottom: solid 1px; width: 200px;">同行者連絡先</th>
              <td style="border-bottom: solid 1px;" colspan="2">
                <b-field
                  :type="{'is-danger':errors.has('companionPhone')}"
                  :message="errors.first('companionPhone')"
                >
                  <b-input
                    v-model="data.companionPhone"
                    name="companionPhone"
                    data-vv-as="同行者連絡先"
                    v-validate="'max:20'"
                  ></b-input>
                </b-field>
              </td>
            </tr>
            <tr>
              <th style="border-bottom: solid 1px; width: 200px;">医療機関名</th>
              <td style="border-bottom: solid 1px;" colspan="2">
                <form action="#">
                  <input type="text" name="a" list="hospitalCodeList" autocomplete="off" v-model="data.hospitalName" expanded style="width:100%;height:38px;" maxlength="150">
                    <datalist id="hospitalCodeList">
                      <option v-for="val in hospitalCodeList" :value="val.hospitalName" :key="val.hospitalName"/>
                    </datalist>
                </form>
              </td>
            </tr>
            <tr>
              <th style="border-bottom: solid 1px; width: 200px;">電話番号</th>
              <td style="border-bottom: solid 1px;" colspan="2">
                <b-field
                  :type="{'is-danger':errors.has('hospitalPhone')}"
                  :message="errors.first('hospitalPhone')"
                >
                  <b-input
                    v-model="data.hospitalPhone"
                    name="hospitalPhone"
                    data-vv-as="電話番号"
                    v-validate="'max:20'"
                  ></b-input>
                </b-field>
              </td>
            </tr>
            <tr>
              <th style="border-bottom: solid 1px; width: 200px;">旅程担当者／所属営業所</th>
              <td style="border-bottom: solid 1px;" colspan="2">
                {{ data.staffName }}  {{ displayStaffMobilePhoneNumber(data.staffmobilePhoneNumber)}} ／{{ data.staffOfficeCode|officeFilter(officeMaster,true)}}
                <b-button
                  v-if="this.type != 'new'&& status!='4' && status!='3'"
                  style="float:right; bottom:0;"
                  class="button is-primary has-text-centered"
                  icon-left="account-switch"
                  native-type="button"
                  v-on:click="changeStaff"
                >担当者変更</b-button>
                <b-modal :active.sync="isManagerChangeActive" has-modal-card>
                  <staffChange-modal
                    v-bind:office-master-list="referenceEnableOfficeList"
                    v-on:staff-change-event="staffChanged"
                  ></staffChange-modal>
                </b-modal>
              </td>
            </tr>
            <tr v-if="data.carryingItems">
              <th style="border-bottom: solid 1px; width: 200px;">患者担当営業所</th>
              <td style="border-bottom: solid 1px;" colspan="2">
                <b-select
                  v-if="officeCodeList.length > 1"
                  expanded
                  v-model="data.inChargeOfficeCode"
                >
                  <option
                    v-for="ofiice in officeCodeList"
                    :value="ofiice.code"
                    :key="ofiice.code"
                  >{{ofiice.code|officeFilter(officeMaster)}}</option>
                </b-select>
                <span v-else>{{data.inChargeOfficeCode|officeFilter(officeMaster)}}</span>
              </td>
            </tr>
            <tr>
              <th style="border-bottom: solid 1px; width: 200px;">持参機器（担当営業所）</th>
              <td style="border-bottom: solid 1px;" colspan="2">
                <b-field
                  class="column"
                  grouped
                  group-multiline
                  :type="{'is-danger':errors.has('carrying')}"
                  :message="errors.first('carrying')"
                >
                  <b-checkbox
                    v-for="(carryingItem,productIndex) in data.carryingItems"
                    v-bind:key="productIndex"
                    v-model="carryingItem.carrying"
                    true-value="true"
                    false-value="false"
                    name="carrying"
                    v-validate="'hasCarring'"
                    v-on:input="inputCheckBox(carryingItem.productCode)"
                  >
                    <a>
                      {{carryingItem.productName}}
                      <span
                        v-if="carryingItem.officeCode"
                      >({{getOfficeName(officeMaster,carryingItem.officeCode)}})</span>
                    </a>
                  </b-checkbox>
                </b-field>
              </td>
            </tr>
            <tr>
              <th style="border-bottom: solid 1px; width: 200px;">手配機器</th>
              <td style="border-bottom: solid 1px;" colspan="2">
                <b-field
                  :type="{'is-danger':errors.has('preparedItems')}"
                  :message="errors.first('preparedItems')"
                >
                  <b-input
                    type="textarea"
                    v-model="data.preparedItems"
                    name="preparedItems"
                    data-vv-as="手配機器"
                    v-validate="'required|max:200'"
                    maxlength="200"
                  ></b-input>
                </b-field>
              </td>
            </tr>
            <tr>
              <th style="border-bottom: solid 1px; width: 200px;">旅行種別</th>
              <td style="border-bottom: solid 1px;" colspan="2">
                <b-field
                  :type="{'is-danger':errors.has('travelType')}"
                  :message="errors.first('travelType')"
                >
                  <b-select
                    v-model="data.travelType"
                    name="travelType"
                    data-vv-as="旅行種別"
                    v-validate="'required|selectRange:1:2'"
                  >
                    <option value="1">個人旅行</option>
                    <option value="2">ツアー参加</option>
                  </b-select>
                </b-field>
              </td>
            </tr>
            <tr>
              <th style="border-bottom: solid 1px; width: 200px;">ツアー会社／支店名</th>
              <td style="border-bottom: solid 1px;" colspan="2">
                <b-field
                  :type="{'is-danger':errors.has('travelAgentName')}"
                  :message="errors.first('travelAgentName')"
                >
                  <b-input
                    v-model="data.travelAgentName"
                    name="travelAgentName"
                    data-vv-as="ツアー会社／支店名"
                    v-validate="'max:100'"
                    maxlength="100"
                  ></b-input>
                </b-field>
              </td>
            </tr>
            <tr>
              <th style="border-bottom: solid 1px; width: 200px;">担当者名</th>
              <td style="border-bottom: solid 1px;" colspan="2">
                <b-field
                  :type="{'is-danger':errors.has('travelAgentStaffName')}"
                  :message="errors.first('travelAgentStaffName')"
                >
                  <b-input
                    v-model="data.travelAgentStaffName"
                    name="travelAgentStaffName"
                    data-vv-as="担当者名"
                    v-validate="'max:50'"
                    maxlength="50"
                  ></b-input>
                </b-field>
              </td>
            </tr>
            <tr>
              <th style="border-bottom: solid 1px; width: 200px;">電話番号</th>
              <td style="border-bottom: solid 1px;" colspan="2">
                <b-field
                  :type="{'is-danger':errors.has('travelAgentPhone')}"
                  :message="errors.first('travelAgentPhone')"
                >
                  <b-input
                    v-model="data.travelAgentPhone"
                    name="travelAgentPhone"
                    data-vv-as="電話番号"
                    v-validate="'max:20'"
                  ></b-input>
                </b-field>
              </td>
            </tr>
            <tr>
              <th style="border-bottom: solid 1px; width: 200px;">担当携帯</th>
              <td style="border-bottom: solid 1px;" colspan="2">
                <b-field
                  :type="{'is-danger':errors.has('travelAgentStaffPhone')}"
                  :message="errors.first('travelAgentStaffPhone')"
                >
                  <b-input
                    v-model="data.travelAgentStaffPhone"
                    name="travelAgentStaffPhone"
                    data-vv-as="担当携帯"
                    v-validate="'max:20'"
                  ></b-input>
                </b-field>
              </td>
            </tr>
            <tr>
              <th style="border-bottom: solid 1px; width: 200px;">移動手段</th>
              <td style="border-bottom: solid 1px;" colspan="2">
                <b-field
                  class="column"
                  grouped
                  group-multiline
                  :type="{'is-danger':errors.has('transportations')}"
                  :message="errors.first('transportations')"
                >
                  <b-checkbox
                    v-model="transportations"
                    native-value="0x000001"
                    id="0x000001"
                    data-vv-as="移動手段"
                    v-validate="`required`"
                    data-vv-validate-on="input"
                    name="transportations"
                  >飛行機</b-checkbox>
                  <b-checkbox
                    v-model="transportations"
                    native-value="0x000010"
                    id="0x000010"
                    data-vv-as="移動手段"
                    v-validate="`required`"
                    data-vv-validate-on="input"
                    name="transportations"
                  >乗用車</b-checkbox>
                  <b-checkbox
                    v-model="transportations"
                    native-value="0x000100"
                    id="0x000100"
                    data-vv-as="移動手段"
                    v-validate="`required`"
                    data-vv-validate-on="input"
                    name="transportations"
                  >鉄道（新幹線）</b-checkbox>
                  <b-checkbox
                    v-model="transportations"
                    native-value="0x001000"
                    id="0x001000"
                    data-vv-as="移動手段"
                    v-validate="`required`"
                    data-vv-validate-on="input"
                    name="transportations"
                  >鉄道（在来線）</b-checkbox>
                  <b-checkbox
                    v-model="transportations"
                    native-value="0x010000"
                    id="0x010000"
                    data-vv-as="移動手段"
                    v-validate="`required`"
                    data-vv-validate-on="input"
                    name="transportations"
                  >船舶</b-checkbox>
                  <b-checkbox
                    v-model="transportations"
                    native-value="0x100000"
                    id="0x100000"
                    data-vv-as="移動手段"
                    v-validate="`required`"
                    data-vv-validate-on="input"
                    name="transportations"
                  >その他</b-checkbox>
                </b-field>
              </td>
            </tr>
            <tr>
              <th style="border-bottom: solid 1px; width: 200px;">移動経路／時間 詳細</th>
              <td style="border-bottom: solid 1px;" colspan="2">
                <b-field
                  :type="{'is-danger':errors.has('routeDetails')}"
                  :message="errors.first('routeDetails')"
                >
                  <b-input
                    type="textarea"
                    v-model="data.routeDetails"
                    name="routeDetails"
                    data-vv-as="移動経路／時間 詳細"
                    v-validate="'required|max:512'"
                    maxlength="512"
                  ></b-input>
                </b-field>
              </td>
            </tr>
            <tr v-for="(item, index) in data.hotelDetails" v-bind:key="item.number">
              <th style="border-bottom: solid 1px;width:15%;" rowspan="10" v-if="index==0">
                宿泊先詳細
                <b-button
                  style="float:right; margin-left:10px;"
                  class="button is-primary has-text-centered"
                  icon-left="calendar-plus"
                  native-type="button"
                  v-on:click="addHotelDetails()"
                ></b-button>
              </th>
              <td style="border-bottom: solid 1px;">
                <div>
                  <!--1行目 -->
                  <div class="columns">
                    <div class="column" style="margin-top: 10px;">
                      <b-field label="宿泊日程" labelPosition="on-border">
                        <b-field
                          :type="{'is-danger':errors.has(getCheckInFieldName(index))}"
                          :message="errors.first(getCheckInFieldName(index))"
                        >
                          <b-datepicker
                            :name="getCheckInFieldName(index)"
                            placeholder="チェックイン年月日"
                            data-vv-as="チェックイン年月日"
                            v-on:input="checkIn(index,hotelStartDate[index])"
                            v-model="hotelStartDate[index]"
                            data-vv-validate-on="input"
                            v-validate="'required|admissionDateCheck'"
                            icon="calendar-today"
                            :month-names="['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']"
                            :day-names="['日','月','火','水','木','金','土']"
                          ></b-datepicker>
                        </b-field>
                        <b-field
                          :type="{'is-danger':errors.has(getCheckOutFieldName(index))}"
                          :message="errors.first(getCheckOutFieldName(index))"
                        >
                          <b-datepicker
                            :name="getCheckOutFieldName(index)"
                            placeholder="チェックアウト年月日"
                            data-vv-as="チェックアウト年月日"
                            v-on:input="checkOut(index,hotelEndDate[index])"
                            v-model="hotelEndDate[index]"
                            data-vv-validate-on="input"
                            v-validate="`required|checkoutDateCheck:${hotelStartDate[index]}|exitDateCheck`"
                            icon="calendar-today"
                            :month-names="['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']"
                            :day-names="['日','月','火','水','木','金','土']"
                          ></b-datepicker>
                        </b-field>
                      </b-field>
                    </div>
                  </div>
                  <!--2行目 -->
                  <div class="columns">
                    <div class="column is-one-second">
                      <b-field
                        label="宿泊先"
                        labelPosition="on-border"
                        :type="{'is-danger':errors.has(getHotelNameField(index))}"
                        :message="errors.first(getHotelNameField(index))"
                      >
                        <b-input
                          expanded
                          v-model="item.hotelName"
                          :name="getHotelNameField(index)"
                          data-vv-as="宿泊先"
                          v-validate="'required|max:80'"
                          maxlength="80"
                        ></b-input>
                      </b-field>
                    </div>
                    <div class="column is-one-second">
                      <b-field
                        label="予約者"
                        labelPosition="on-border"
                        :type="{'is-danger':errors.has(getBookingNameField(index))}"
                        :message="errors.first(getBookingNameField(index))"
                      >
                        <b-input
                          expanded
                          v-model="item.bookingName"
                          :name="getBookingNameField(index)"
                          data-vv-as="予約者"
                          v-validate="'required|max:50'"
                          maxlength="50"
                        ></b-input>
                      </b-field>
                    </div>
                  </div>
                  <!--3行目 -->
                  <div class="columns">
                    <div class="column is-one-quarter">
                      <b-field
                        label="都道府県名"
                        labelPosition="on-border"
                        :type="{'is-danger':errors.has(getPrefecturesField(index))}"
                        :message="errors.first(getPrefecturesField(index))"
                      >
                        <b-input
                          v-model="item.prefectures"
                          :name="getPrefecturesField(index)"
                          data-vv-as="都道府県名"
                          v-validate="'required|max:10'"
                          maxlength="10"
                        ></b-input>
                      </b-field>
                    </div>
                    <div class="column">
                      <b-field
                        label="宿泊先住所"
                        labelPosition="on-border"
                        :type="{'is-danger':errors.has(getAddressField(index))}"
                        :message="errors.first(getAddressField(index))"
                      >
                        <b-input
                          expanded
                          v-model="item.address"
                          :name="getAddressField(index)"
                          data-vv-as="宿泊先住所"
                          v-validate="'required|max:100'"
                          maxlength="100"
                        ></b-input>
                      </b-field>
                    </div>
                  </div>
                  <!--4行目 -->
                  <div class="columns">
                    <div class="column is-one-quarter">
                      <b-field
                        label="電話番号"
                        labelPosition="on-border"
                        :type="{'is-danger':errors.has(getPhoneFieldName(index))}"
                        :message="errors.first(getPhoneFieldName(index))"
                      >
                        <b-input
                          expanded
                          v-model="item.phone"
                          :name="getPhoneFieldName(index)"
                          data-vv-as="電話番号"
                          v-validate="'required|max:20'"
                        ></b-input>
                      </b-field>
                    </div>
                    <div class="column is-4">
                      <b-field
                        label="依頼先営業所"
                        labelPosition="on-border"
                        :type="{'is-danger':errors.has(getTravelOfficeNameField(index))}"
                        :message="errors.first(getTravelOfficeNameField(index))"
                      >
                        <b-select
                          expanded
                          :name="getTravelOfficeNameField(index)"
                          data-vv-as="依頼先営業所"
                          v-model="item.officeCode"
                          v-validate="'required'"
                          @input="inputTravelOffice(index)"
                        >
                          <option
                            v-for="office in officeMaster"
                            :value="office.officeCode"
                            :key="office.officeCode"
                            :disabled="item.completeFlag"
                          >{{ office.officeName }}</option>
                        </b-select>
                      </b-field>
                    </div>
                    <div class="column is-5">
                      <b-field
                        v-if="type=='edit' && checkOffice(data.officeCode)"
                        label="設置依頼"
                        labelPosition="on-border"
                        :type="{'is-danger':errors.has(getRequestFlagField(index))}"
                        :message="errors.first(getRequestFlagField(index))"
                      >
                        <div
                          :name="getRequestFlagField(index)"
                          style="width: 80px;font-size:16px;line-height: 3.0;text-align:center;"
                        >{{item.requestFlag ? "あり" : "なし"}}</div>
                      </b-field>
                      <b-field
                        v-else
                        label="設置依頼"
                        labelPosition="on-border"
                      >
                        <b-select
                          expanded
                          :name="getRequestFlagField(index)"
                          data-vv-as="設置依頼"
                          v-model="item.requestFlag"
                          style="width: 125px;"
                          @input="inputRequestFlag(index)"
                        >
                          <option :value="true" :disabled="item.completeFlag">あり</option>
                          <option :value="false" :disabled="item.completeFlag">なし</option>
                        </b-select>
                        <span style="color:red;margin-left:10px;text-align:top;text-size:12px;" v-if="item.completeFlag">
                          設置完了している為、<br>「依頼先営業所」「設置依頼」の変更はできません。<br>変更する場合は、<br>依頼先営業所より「設置状況」の更新を行ってください。
                        </span>
                      </b-field>
                    </div>
                  </div>
                  <div class="columns" style="margin-top:10px;">
                    <div style="width:50%;margin-left:15px;">
                      <b-field
                        label="依頼確認状況"
                        labelPosition="on-border"
                        :type="{'is-danger':errors.has(getConfirmationFlagField(index))}"
                        :message="errors.first(getConfirmationFlagField(index))"
                      >
                        <b-checkbox
                          :name="getConfirmationFlagField(index)"
                          v-model="item.confirmationFlag"
                          style="width: 25px;font-size:15px;margin-top:10px;"
                          value="false"
                          :disabled="type!='edit' || !item.targetSalesOfficeUserFlag"
                        ></b-checkbox>
                          <span style="font-size:15px;margin-top:10px;">
                            確認済み
                            <span
                              v-if="item.confirmationStaffName"
                              style="margin-left:5px;margin-top:10px;"
                            >(最終更新者：{{getRowItem(item.confirmationStaffName, 10)}})</span>
                          </span>
                      </b-field>
                    </div>
                    <div style="width:50%;padding-left:10px;">
                      <b-field
                        label="設置状況"
                        labelPosition="on-border"
                        :type="{'is-danger':errors.has(getCompleteFlagField(index))}"
                        :message="errors.first(getCompleteFlagField(index))"
                      >
                        <b-checkbox
                          :name="getCompleteFlagField(index)"
                          v-model="item.completeFlag"
                          style="width:25px;font-size:15px;margin-top:10px;"
                          value="false"
                          :disabled="type!=='edit' || !item.targetSalesOfficeUserFlag || !item.requestFlag"
                        ></b-checkbox>
                          <span style="font-size:15px;margin-top:10px;">
                            完了
                            <span
                              v-if="item.completeStaffName"
                              style="margin-left:10px;"
                            >(最終更新者：{{getRowItem(item.completeStaffName, 10)}})</span>
                          </span>
                      </b-field>
                    </div>
                  </div>
                  <div class="columns" style="margin-top:10px;">
                    <div class="column is-full">
                      <b-field
                        label="申し送り事項"
                        labelPosition="on-border"
                        :type="{'is-danger':errors.has(getNoteField(index))}"
                        :message="errors.first(getNoteField(index))"
                      >
                        <b-input
                          type="textarea"
                          v-model="item.note"
                          :readonly="type=='edit' && checkOffice(data.officeCode)"
                          :name="getNoteField(index)"
                          data-vv-as="申し送り事項"
                          v-validate="'required|max:512'"
                          maxlength="512"
                        ></b-input>
                      </b-field>
                    </div>
                  </div>
                </div>
              </td>
              <td style="border-bottom: solid 1px;">
                <b-button
                  v-if="index > 0"
                  style="float:right; margin-left:10px;"
                  class="button is-primary has-text-centered"
                  icon-left="calendar-remove"
                  native-type="button"
                  v-on:click="data.hotelDetails.splice(index, 1)"
                ></b-button>
              </td>
            </tr>
          </table>
        </div>
        <div v-else>
          <div style="height:10px;"></div>
          <table style="width: 100%;" class="table">
            <tr v-if="type === 'edit'">
              <td style="border-bottom: solid 0px;" colspan="2">
                <div style="text-align:right;">
                  <b-button
                    v-on:click="refDetail(data)"
                    class="button"
                    type="is-primary"
                    icon-left="alert-circle"
                    native-type="button"
                  >患者情報閲覧</b-button>
                  <b-button
                    v-on:click="goToPatientSearch(data)"
                    class="button"
                    type="is-primary"
                    icon-left="alert-circle"
                    native-type="button"
                  >患者情報閲覧（検索）</b-button>
                </div>
              </td>
            </tr>

            <tr>
              <th style="border-bottom: solid 1px; width: 200px;">旅行期間</th>
              <td style="border-bottom: solid 1px;" colspan="2">
                <span>{{data.startDate}}</span>
                ～
                <span>{{data.endDate}}</span>
              </td>
            </tr>
            <tr>
              <th style="border-bottom: solid 1px; width: 200px;">患者名（患者名カナ）</th>
              <td style="border-bottom: solid 1px;" colspan="2">
                <span>
                  {{data.patientName}}
                  <template
                    v-if="data.patientNameKana"
                  >（{{data.patientNameKana}}）</template>
                </span>
              </td>
            </tr>
            <tr>
              <th style="border-bottom: solid 1px; width: 200px;">連絡先</th>
              <td style="border-bottom: solid 1px;" colspan="2">
                <span>{{ data.patientPhone }}</span>
              </td>
            </tr>
            <tr>
              <th style="border-bottom: solid 1px; width: 200px;">同行者名</th>
              <td style="border-bottom: solid 1px;" colspan="2">
                <span>{{data.companionName}}</span>
              </td>
            </tr>
            <tr>
              <th style="border-bottom: solid 1px; width: 200px;">同行者連絡先</th>
              <td style="border-bottom: solid 1px;" colspan="2">
                <span>{{data.companionPhone}}</span>
              </td>
            </tr>
            <tr>
              <th style="border-bottom: solid 1px; width: 200px;">医療機関名</th>
              <td style="border-bottom: solid 1px;" colspan="2">
                <span>{{data.hospitalName}}</span>
              </td>
            </tr>
            <tr>
              <th style="border-bottom: solid 1px; width: 200px;">電話番号</th>
              <td style="border-bottom: solid 1px;" colspan="2">
                <span>{{data.hospitalPhone}}</span>
              </td>
            </tr>
            <tr>
              <th style="border-bottom: solid 1px; width: 200px;">旅程担当者／所属営業所</th>
              <td style="border-bottom: solid 1px;" colspan="2">
                {{ data.staffName }} {{displayStaffMobilePhoneNumber(data.staffmobilePhoneNumber)}} ／{{ data.staffOfficeCode|officeFilter(officeMaster,true)}}
                <b-button
                  v-if="this.type != 'new'&& status!='4' && status!='3'"
                  style="float:right; bottom:0;"
                  class="button is-primary has-text-centered"
                  icon-left="account-switch"
                  native-type="button"
                  v-on:click="changeStaff"
                >担当者変更</b-button>
                <b-modal :active.sync="isManagerChangeActive" has-modal-card>
                  <staffChange-modal
                    v-bind:office-master-list="referenceEnableOfficeList"
                    v-on:staff-change-event="staffChanged"
                  ></staffChange-modal>
                </b-modal>
              </td>
            </tr>
            <tr v-if="data.carryingItems.length > 0">
              <th style="border-bottom: solid 1px; width: 200px;">患者担当営業所</th>
              <td style="border-bottom: solid 1px;" colspan="2">
                <span>{{data.inChargeOfficeCode|officeFilter(officeMaster)}}</span>
              </td>
            </tr>
            <tr>
              <th style="border-bottom: solid 1px; width: 200px;">持参機器（担当営業所）</th>
              <td style="border-bottom: solid 1px;" colspan="2">
                <b-field
                  class="column"
                  grouped
                  group-multiline
                  :type="{'is-danger':errors.has('carrying')}"
                  :message="errors.first('carrying')"
                >
                  <b-checkbox
                    v-for="carryingItem in data.carryingItems"
                    v-bind:key="carryingItem.productCode"
                    v-model="carryingItem.carrying"
                    true-value="true"
                    false-value="false"
                    name="carrying"
                    v-validate="'hasCarring'"
                    :disabled="true"
                  >
                    <a>
                      {{carryingItem.productName}}
                      <span
                        v-if="carryingItem.officeCode"
                      >({{getOfficeName(officeMaster,carryingItem.officeCode)}})</span>
                    </a>
                  </b-checkbox>
                </b-field>
              </td>
            </tr>
            <tr>
              <th style="border-bottom: solid 1px; width: 200px;">手配機器</th>
              <td style="border-bottom: solid 1px;" colspan="2">
                <b-field
                  :type="{'is-danger':errors.has('preparedItems')}"
                  :message="errors.first('preparedItems')"
                >
                  <b-input
                    type="textarea"
                    v-model="data.preparedItems"
                    name="preparedItems"
                    data-vv-as="手配機器"
                    v-validate="'required|max:200'"
                    maxlength="200"
                    :readonly="true"
                  ></b-input>
                </b-field>
              </td>
            </tr>
            <tr>
              <th style="border-bottom: solid 1px; width: 200px;">旅行種別</th>
              <td style="border-bottom: solid 1px;" colspan="2">
                <span>{{data.travelType|travelTypeFillter}}</span>
              </td>
            </tr>
            <tr>
              <th style="border-bottom: solid 1px; width: 200px;">ツアー会社／支店名</th>
              <td style="border-bottom: solid 1px;" colspan="2">
                <span>{{data.travelAgentName}}</span>
              </td>
            </tr>
            <tr>
              <th style="border-bottom: solid 1px; width: 200px;">担当者名</th>
              <td style="border-bottom: solid 1px;" colspan="2">
                <span>{{data.travelAgentStaffName}}</span>
              </td>
            </tr>
            <tr>
              <th style="border-bottom: solid 1px; width: 200px;">電話番号</th>
              <td style="border-bottom: solid 1px;" colspan="2">
                <span>{{data.travelAgentPhone}}</span>
              </td>
            </tr>
            <tr>
              <th style="border-bottom: solid 1px; width: 200px;">担当携帯</th>
              <td style="border-bottom: solid 1px;" colspan="2">
                <span>{{data.travelAgentStaffPhone}}</span>
              </td>
            </tr>
            <tr>
              <th style="border-bottom: solid 1px; width: 200px;">移動手段</th>
              <td style="border-bottom: solid 1px;" colspan="2">
                <b-field
                  class="column"
                  grouped
                  group-multiline
                  :type="{'is-danger':errors.has('transportations')}"
                  :message="errors.first('transportations')"
                >
                  <b-checkbox
                    v-model="transportations"
                    native-value="0x000001"
                    id="0x000001"
                    data-vv-as="移動手段"
                    v-validate="`required`"
                    data-vv-validate-on="input"
                    name="transportations"
                    :disabled="true"
                  >飛行機</b-checkbox>
                  <b-checkbox
                    v-model="transportations"
                    native-value="0x000010"
                    id="0x000010"
                    data-vv-as="移動手段"
                    v-validate="`required`"
                    data-vv-validate-on="input"
                    name="transportations"
                    :disabled="true"
                  >乗用車</b-checkbox>
                  <b-checkbox
                    v-model="transportations"
                    native-value="0x000100"
                    id="0x000100"
                    data-vv-as="移動手段"
                    v-validate="`required`"
                    data-vv-validate-on="input"
                    name="transportations"
                    :disabled="true"
                  >鉄道（新幹線）</b-checkbox>
                  <b-checkbox
                    v-model="transportations"
                    native-value="0x001000"
                    id="0x001000"
                    data-vv-as="移動手段"
                    v-validate="`required`"
                    data-vv-validate-on="input"
                    name="transportations"
                    :disabled="true"
                  >鉄道（在来線）</b-checkbox>
                  <b-checkbox
                    v-model="transportations"
                    native-value="0x010000"
                    id="0x010000"
                    data-vv-as="移動手段"
                    v-validate="`required`"
                    data-vv-validate-on="input"
                    name="transportations"
                    :disabled="true"
                  >船舶</b-checkbox>
                  <b-checkbox
                    v-model="transportations"
                    native-value="0x100000"
                    id="0x100000"
                    data-vv-as="移動手段"
                    v-validate="`required`"
                    data-vv-validate-on="input"
                    name="transportations"
                    :disabled="true"
                  >その他</b-checkbox>
                </b-field>
              </td>
            </tr>
            <tr>
              <th style="border-bottom: solid 1px; width: 200px;">移動経路／時間 詳細</th>
              <td style="border-bottom: solid 1px;" colspan="2">
                <b-field
                  :type="{'is-danger':errors.has('routeDetails')}"
                  :message="errors.first('routeDetails')"
                >
                  <b-input
                    type="textarea"
                    v-model="data.routeDetails"
                    name="routeDetails"
                    data-vv-as="移動経路／時間 詳細"
                    v-validate="'required|max:512'"
                    maxlength="512"
                    :readonly="true"
                  ></b-input>
                </b-field>
              </td>
            </tr>
            <tr v-for="(item, index) in data.hotelDetails" v-bind:key="item.number">
              <th style="border-bottom: solid 1px;width:15%;" rowspan="10" v-if="index==0">
                宿泊先詳細
                <b-button
                  style="float:right; margin-left:10px;"
                  class="button is-primary has-text-centered"
                  icon-left="calendar-plus"
                  native-type="button"
                  v-on:click="addHotelDetails()"
                  :disabled="true"
                ></b-button>
              </th>
              <td style="border-bottom: solid 1px;">
                <div>
                  <!--1行目 -->
                  <div class="columns">
                    <div class="column" style="margin-top: 10px;">
                      宿泊期間：
                      <span>{{formatDate(hotelStartDate[index])}}</span>
                      ～
                      <span>{{formatDate(hotelEndDate[index])}}</span>
                    </div>
                  </div>
                  <!--2行目 -->
                  <div class="columns">
                    <div class="column is-one-second">
                      宿泊先:
                      <span>{{item.hotelName}}</span>
                    </div>
                    <div class="column is-one-second">
                      予約者：
                      <span>{{item.bookingName}}</span>
                    </div>
                  </div>
                  <!--3行目 -->
                  <div class="columns">
                    <div class="column is-one-second">
                      都道府県：
                      <span>{{item.prefectures}}</span>
                    </div>
                    <div class="column is-one-second">
                      宿泊先住所：
                      <span>{{item.address}}</span>
                    </div>
                  </div>
                  <!--4行目 -->
                  <div class="columns">
                    <div class="column is-3">
                      電話番号：
                      <span>{{item.phone}}</span>
                    </div>
                    <div class="column is-6">
                      依頼先営業所：
                      <span>{{getOfficeName(officeMaster,item.officeCode)}}</span>
                    </div>
                    <div class="column is-2" style="margin-left: 10px;">
                      設置依頼：
                      <span>{{item.requestFlag ? "あり" : "なし"}}</span>
                    </div>
                  </div>
                  <div class="columns">
                    <div style="width:50%;margin-left:15px;">
                      依頼確認状況：
                      <b-checkbox v-model="item.confirmationFlag" style="width: 20px;" disabled></b-checkbox>
                      <span>確認済み
                        <span v-if="item.confirmationStaffName">(最終更新者：{{getRowItem(item.confirmationStaffName, 10)}})</span>
                      </span>
                    </div>
                    <div style="width:50%;padding-left:10px;">
                      設置状況：
                      <b-checkbox v-model="item.completeFlag" style="width: 20px;" disabled></b-checkbox>
                      <span>完了
                        <span v-if="item.completeStaffName">(最終更新者：{{getRowItem(item.completeStaffName, 10)}})</span>
                      </span>
                    </div>
                  </div>
                  <div class="columns">
                    <div class="column is-full">
                      <b-field
                        label="申し送り事項"
                        labelPosition="on-border"
                        :type="{'is-danger':errors.has(getNoteField(index))}"
                        :message="errors.first(getNoteField(index))"
                      >
                        <b-input
                          type="textarea"
                          v-model="item.note"
                          :readonly="true"
                          :name="getNoteField(index)"
                          data-vv-as="申し送り事項"
                          v-validate="'required|max:512'"
                          maxlength="512"
                        ></b-input>
                      </b-field>
                    </div>
                  </div>
                </div>
              </td>
              <td style="border-bottom: solid 1px;">
                <b-button
                  v-if="index > 0"
                  style="float:right; margin-left:10px;"
                  class="button is-primary has-text-centered"
                  icon-left="calendar-remove"
                  native-type="button"
                  v-on:click="data.hotelDetails.splice(index, 1)"
                  :disabled="true"
                ></b-button>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <!-- 余白 -->
    <div style="height: 50px;" />
    <!-- 戻るボタン -->
    <div style="text-align:center;">
      <b-button
        v-on:click="back"
        class="button"
        type="is-primary"
        icon-left="keyboard-backspace"
        native-type="button"
      >戻る</b-button>
      <b-button
        v-if="!editFlg&&status=='1'||!editFlg&&status=='2'||!editFlg&&status=='5'||!editFlg&&status=='6'"
        v-on:click="save"
        class="button"
        type="is-primary"
        icon-left="content-save"
        native-type="button"
      >登録</b-button>
      <b-button
        v-if="!editFlg&&status=='2' "
        v-on:click="compleat"
        class="button"
        type="is-primary"
        icon-left="content-save"
        native-type="button"
      >完了</b-button>
      <b-button
        v-if="type!='copy'&&!editFlg&&status=='1' ||type!='copy'&& !editFlg&&status=='5' "
        v-on:click="cancel"
        class="button"
        type="is-primary"
        icon-left="select-off"
        native-type="button"
        :disabled="this.CompSalesOfficeCode != this.CompOfficeCodeUserInfo && this.role != 1"
      >キャンセル</b-button>
    </div>
    <!-- 下部余白 -->
    <div style="height: 10px;" />
  </div>
</template>

<script>
import SelectPatientTemplate from "./AppPatientSearch";
import StaffSearchTemplate from "./AppSelectStaff";
var transportations = [];
var compleateFlg = false;
const SelectPatientForm = {
  methods: {
    select: function() {
      var item = this.$refs.selectedPatient.getSelectedItem();
      var flg = false;
      // 選択結果を画面に反映
      if (item) {
        var roleId = JSON.parse(sessionStorage.getItem("userInfo")).roleId;
        if (roleId != 1 && roleId != 2) {
          var selectOfficeCodes = item.officeCode.split(",");
          var officeCode = JSON.parse(sessionStorage.getItem("userInfo"))
            .officeCode;
          var officeCodes = JSON.parse(sessionStorage.getItem("userInfo"))
            .referenceOfficeCodes;
          for (var i = 0; i < selectOfficeCodes.length; i++) {
            if (selectOfficeCodes[i] == officeCode) {
              flg = true;
              break;
            }
            for (var j = 0; j < officeCodes.length; j++) {
              if (selectOfficeCodes[i] == officeCodes[j]) {
                flg = true;
                break;
              }
            }
          }
          if (flg) {
            this.$emit("set-patient", item);
            this.$parent.close();
          } else {
            this.showErrorMessage(
              "自身の所属する営業所 もしくは 参照可能である営業所<br>に紐付く情報を選択してください"
            );
          }
        } else {
          this.$emit("set-patient", item);
          this.$parent.close();
        }
      } else {
        this.showErrorMessage("患者情報を選択してください");
      }
    }
  },
  components: {
    selectPatient: SelectPatientTemplate
  },
  template: `
    <form style="width: 90%;height:30px;margin-left: 5%;margin-top: 1%;">
      <div class="modal-card" style="width: 100%;">
        <section class="modal-card-body" style="width: 100%;height:100%;">
          <selectPatient ref="selectedPatient" v-bind:select-mode="true" v-bind:is-nationwide-search="false" :multiSelectMode="false"/>
          <div style="height: 10px;" />
          </section>
        <footer style="text-align:center;">
          <b-button
           v-on:click=$parent.close()
           class="button"
           type="is-primary"
           icon-left="keyboard-backspace"
           native-type="button"
          >戻る</b-button>
          <b-button                       
           v-on:click="select"
           class="button"
           type="is-primary"
           icon-left="content-save"
           native-type="button"
          >選択</b-button>
          <div style="height: 10px;" />
        </footer>
      </div>
    </form>
`
};

const StaffChangeModalForm = {
  props: ["officeMasterList"],
  components: {
    staffSearch: StaffSearchTemplate
  },
  methods: {
    save: function(event) {
      // 選択されている担当者を取得
      var staffInfo = this.$refs.staffList.getStaff();

      // 選択された担当者情報を親画面に返却
      this.$emit(
        "staff-change-event",
        staffInfo.officeCode,
        staffInfo.officeName,
        staffInfo.staffCode,
        staffInfo.lastName + staffInfo.firstName,
        staffInfo.id,
        staffInfo.mobilePhoneNumber,
      );
      this.$parent.close();
    }
  },
  data() {
    var referenceEnableOfficeList = this.$props.officeMasterList;
    return {
      referenceEnableOfficeList
    };
  },
  template: `
        <form action="">
          <div class="modal-card" style="width: 800px;">
            <header class="modal-card-head">
                <p class="modal-card-title" style="color: whitesmoke;">担当者変更</p>
            </header>
            <section class="modal-card-body">
              <staffSearch ref="staffList" v-bind:office-master-list="referenceEnableOfficeList"/>
            </section>
            <footer class="modal-card-foot">
                <button class="button" type="button" @click="save">決定</button>
                <button class="button" type="button" @click="$parent.close()">閉じる</button>
            </footer>
          </div>
        </form>
      `
};

export default {
  name: "AppDomesticTravel",
  methods: {
    getRowItem: function(value, length) {
      return value.length > length ? value.substr(0, length) + "..." : value;
    },
    flgCheck: function() {
      for (var i in this.data.hotelDetails) {
        this.data.hotelDetails[i].requestFlag = (this.data.hotelDetails[i].requestFlag == "true" || this.data.hotelDetails[i].requestFlag == true) ? true : false
        this.data.hotelDetails[i].confirmationFlag = (this.data.hotelDetails[i].confirmationFlag == "true" || this.data.hotelDetails[i].confirmationFlag == true) ? true : false
        this.data.hotelDetails[i].completeFlag = (this.data.hotelDetails[i].completeFlag == "true" || this.data.hotelDetails[i].completeFlag == true) ? true : false
      }
      var result = {
        errFlag:false,
        errMessage:""
      }
      var editTripHistory = this.data.hotelDetails.find((val) => 
      val.targetSalesOfficeUserFlag && val.completeFlag &&(
      !val.requestFlag || !val.confirmationFlag
      ))
      if(editTripHistory){
        result.errFlag = true
        result.errMessage="「設置状況」を完了に更新できるのは、\n「設置依頼」がありで、「依頼確認状況」が確認済み\nの旅程のみです。"
      }
      return result
    },
    checkOffice: function(officeCode) {
      if (officeCode != JSON.parse(sessionStorage.getItem("userInfo")).officeCode) {
        return true;
      }
      return false;
    },
    addHotelDetails: function() {
      if (this.data.hotelDetails.length < 10) {
        this.data.hotelDetails.push({requestFlag:false});
      } else {
        this.showErrorMessage("宿泊先は10件までしか登録できません。");
      }
    },
    checkType: function(value) {
      // 国内旅行移動手段
      var TRIP_METHOD_TYPE = {
        AIR_PLANE: { code: 0x000001, value: "0x000001" },
        CAR: { code: 0x000010, value: "0x000010" },
        SHINKANSEN: { code: 0x000100, value: "0x000100" },
        TRAIN: { code: 0x001000, value: "0x001000" },
        SHIP: { code: 0x010000, value: "0x010000" },
        OTHER: { code: 0x100000, value: "0x100000" }
      };
      var tripMethodList = [];
      for (var d in TRIP_METHOD_TYPE) {
        if ((value & TRIP_METHOD_TYPE[d].code) != 0) {
          tripMethodList.push(TRIP_METHOD_TYPE[d].value);
        }
      }
      return tripMethodList;
    },
    cancel: function(event) {
      var checkResult = this.flgCheck()
      if(checkResult.errFlag){
        this.showErrorMessage(checkResult.errMessage);
        return
      }
      this.$validator.validateAll().then(validatorResult => {
        if (validatorResult) {
          this.newStatus = 3;
          this.regist().then(result => {
            if (this.compleateFlg) {
              this.doReturn();
            }
          });
        } else {
          scrollTo(0, 0);
        }
      });
    },
    back: function(event) {
      this.doReturn();
    },
    doReturn: function(event) {
      this.$router.push({
        name: "AppDomesticTravelSearch",
        params: { searchConditions: this.searchConditions }
      });
    },
    save: function(event) {
      var checkResult = this.flgCheck()
      if(checkResult.errFlag){
        this.showErrorMessage(checkResult.errMessage);
        return
      }
      this.$validator.validateAll().then(validatorResult => {
        if (validatorResult) {
          this.regist().then(result => {
            if (this.compleateFlg) {
              this.doReturn();
            }
          });
        } else {
          scrollTo(0, 0);
        }
      });
    },
    compleat: function(event) {
      this.flgCheck()
      this.$validator.validateAll().then(validatorResult => {
        if (validatorResult) {
          this.newStatus = 4;
          this.regist().then(result => {
            if (this.compleateFlg) {
              this.doReturn();
            }
          });
        } else {
          scrollTo(0, 0);
        }
      });
    },
    regist: function() {
      // 担当支店の整合性チェック
      var targetOfficeCode = [];
      for (var i in this.data.carryingItems) {
        if (typeof this.data.carryingItems[i].carrying != "boolean") {
          this.data.carryingItems[i].carrying = this.parseBoolean(
            this.data.carryingItems[i].carrying
          );
        }
        if (this.data.carryingItems[i].carrying) {
          // 持参機器にチェックが入っている場合
          var office = this.data.carryingItems[i].officeCode;
          var isExistence = targetOfficeCode.filter(val => val.code == office);
          if (isExistence.length == 0) {
            // 対象営業所リストに存在しない場合
            targetOfficeCode.push({ code: office });
          }
        }
      }
      if (!(targetOfficeCode.length == 1 && targetOfficeCode[0].code == "")) {
        var isExistenceOffice = targetOfficeCode.filter(
          val => val.code == this.data.inChargeOfficeCode
        );
        if (!isExistenceOffice || isExistenceOffice.length == 0) {
          this.showErrorMessage(
            "「患者担当営業所」<br>チェックを入れた持参機器の営業所の中から患者担当営業所を選択してください。"
          );
          scrollTo(0, 0);
          this.compleateFlg = false;
          return new Promise(resolve => {
            resolve();
          });
        }
      }
      var excuteApi = this.setTravelInfoPOST;
      var successCallBack = this.setTravelInfoPOSTSuccess;
      var errorCallBack = this.setTravelInfoPOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setTravelInfoPOST: function(client) {
      if (this.newStatus == 3 || this.newStatus == 4) {
        this.data.status = this.newStatus;
      }
      var totalTransportation = 0;
      for (var item in this.transportations) {
        var s = this.transportations[item].replace("0x", "");
        var i = parseInt(s, 16);
        totalTransportation = totalTransportation + i;
      }
      this.data.transportations = totalTransportation;
      var today = new Date();
      var time = "";
      time += this.formatDate(today);
      time += this.formatTime(today);
      time += ":" + today.getSeconds();
      time += "." + today.getMilliseconds();
      this.data.updateTime = time;
      this.data.travelType = parseInt(this.data.travelType);
      this.startDate;
      this.endDate;
      if (this.type === "copy") {
        delete this.data.domesticTravelCode;
      }
      if (this.data.status == 6) {
        this.data.status = 1;
      }
      // 担当支店名の設定
      this.data.inChargeOfficeName = this.getOfficeName(
        this.officeMaster,
        this.data.inChargeOfficeCode
      );
      var obj = JSON.parse(JSON.stringify(this.data));
      return client.apis.apiTravel.setTravelInfoPOST({
        body: obj
      });
    },
    setTravelInfoPOSTSuccess: function(result) {
      // 成功メッセージ表示
      this.showSuccess(result);
      this.compleateFlg = true;
    },
    setTravelInfoPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    setPatientName: function(item) {
      this.data.doctorName = "";
      this.data.patientCode = "";
      this.data.patientName = "";
      (this.data.patientNameKana = ""), (this.data.patientPhone = "");
      this.data.patientCode = item.patientCode;
      this.data.patientName = item.patientName;
      this.data.patientNameKana = item.patientNameKana;
      this.data.patientPhone = item.patientPhone;
      this.errors.remove("patientName");
      this.errors.remove("patientPhone");
      if (item.productDetail.length != 0) {
        var setItems = [
          {
            productCode: "",
            serialNumber: "",
            productName: "持参機器無し",
            officeCode: "",
            carrying: false
          }
        ];
        this.officeCodeList = [];
        this.hospitalCodeList = [];
        for (var i in item.productDetail) {
          if (item.productDetail[i].doctorName) {
            this.data.doctorName = item.productDetail[i].doctorName;
          }
          // if (item.productDetail[i].hospitalName) {
          //   this.data.doctorName = item.productDetail[i].doctorName;
          // }
          var office = item.productDetail[i].officeCode;
          var hospitalCode = item.productDetail[i].hospitalCode;
          var hospitalName = item.productDetail[i].hospitalName;
          if (office.startsWith("J") || office.startsWith("C")) {
            office = office.substr(1);
          }
          var isExistence = this.officeCodeList.filter(
            val => val.code == office
          );
          if (isExistence.length == 0) {
            this.officeCodeList.push({ code: office });
          }
          var isExistenceHospital = this.hospitalCodeList.filter(
            val => val.hospitalCode == hospitalCode
          );
          if (isExistenceHospital.length == 0) {
            this.hospitalCodeList.push({ hospitalCode: hospitalCode, hospitalName: hospitalName });
          }
          setItems.push({
            productCode: item.productDetail[i].productCode,
            serialNumber: item.productDetail[i].serialNumber,
            productName: item.productDetail[i].productName,
            officeCode: office,
            hospitalCode: hospitalCode,
            hospitalName: hospitalName,
            carrying: true
          });
        }
        this.data.inChargeOfficeCode = this.officeCodeList[0].code;
        this.data.hospitalCode = this.hospitalCodeList.length == 1 ? this.hospitalCodeList[0].hospitalCode : "";
        this.data.hospitalName = this.hospitalCodeList.length == 1 ? this.hospitalCodeList[0].hospitalName : "";
        this.data.carryingItems = setItems;
      }
    },
    goToPatientSearch: function(data) {
      var conditions = {
        patientCode: data.patientCode,
        patientName: data.patientName
      };
      this.$router.push({
        name: "AppPatientSearch",
        params: { searchConditions: conditions }
      });
    },
    refDetail: function(data) {
      this.$router.push({
        name: "AppPatientDetail",
        params: {
          code: data.patientCode,
          type: this.type,
          domesticTravelCode : this.domesticTravelCodeRet,
          status: this.status,
          searchConditions: this.searchConditions,
          editFlg: this.editFlg,
          callUi:"AppDomesticTravel"
        }
      });
    },    
    dateParser: function(value) {
      return new Date(value);
    },
    changePatient: function(value) {
      this.isSelectPatientActive = true;
    },
    getPhoneFieldName: function(index) {
      return "phone" + index;
    },
    getHotelNameField: function(index) {
      return "hotelname" + index;
    },
    getBookingNameField: function(index) {
      return "bookingName" + index;
    },
    getPrefecturesField: function(index) {
      return "prefectures" + index;
    },
    getAddressField: function(index) {
      return "address" + index;
    },
    getNoteField: function(index) {
      return "note" + index;
    },
    getCheckInFieldName: function(index) {
      return "checkIn" + index;
    },
    getCheckOutFieldName: function(index) {
      return "checkOut" + index;
    },
    getTravelOfficeNameField: function(index) {
      return "office" + index;
    },
    getRequestFlagField: function(index) {
      return "requestFlag" + index;
    },
    getConfirmationFlagField: function(index) {
      return "confirmationFlag" + index;
    },
    getCompleteFlagField: function(index) {
      return "completeFlag" + index;
    },
    getTravelInfoPOST: function(client) {
      this.code = parseInt(this.code);
      return client.apis.apiTravel.getTravelInfoPOST({
        body: {
          code: this.code,
          copyFlag: this.type == "copy"
        }
      });
    },
    getTravelInfoPOSTSuccess: function(result) {
      // WebAPI応答内容を画面に設定
      this.data = result.obj;
      if (this.type === "copy") {
        // 複写用の初期化処理
        this.data.domesticTravelCode = "";
        this.data.startDate = "";
        this.data.endDate = "";
        var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
        var officeName = this.getOfficeName(
          this.officeMaster,
          userInfo.officeCode
        );
        this.data.officeCode = userInfo.officeCode;
        this.data.officeName = officeName;
        this.data.staffCode = userInfo.staffCode;
        this.data.staffId = userInfo.id;
        this.data.staffName = userInfo.fullName;
        this.data.staffmobilePhoneNumber = userInfo.mobilePhoneNumber;
        this.data.staffOfficeCode = userInfo.officeCode;
        for (let i = 0; i < this.data.hotelDetails.length; i++) {
          this.data.hotelDetails[i].startDate = null;
          this.data.hotelDetails[i].endDate = null;
          this.data.hotelDetails[i].officeCode = "";
          this.data.hotelDetails[i].confirmationFlag = false;
          this.data.hotelDetails[i].confirmationStaffName = null;
          this.data.hotelDetails[i].completeFlag = false;
          this.data.hotelDetails[i].completeStaffName = null;
        }
        if (this.data.status == 3 || this.data.status == 4) {
          this.data.status = 1;
        }
      }
      // 移動手段のチェック用変換処理
      this.transportations = this.checkType(this.data.transportations);
      this.status = this.data.status;
      // 文字列⇒Date型変換処理(旅行期間,宿泊日程)
      if (this.data.startDate) {
        this.startDate = this.parseDate(this.data.startDate);
      }
      if (this.data.endDate) {
        this.endDate = this.parseDate(this.data.endDate);
      }
      for (let i = 0; i < this.data.hotelDetails.length; i++) {
        if (this.data.hotelDetails[i].startDate) {
          this.hotelStartDate[i] = this.parseDate(
            this.data.hotelDetails[i].startDate
          );
        }
        if (this.data.hotelDetails[i].endDate) {
          this.hotelEndDate[i] = this.parseDate(
            this.data.hotelDetails[i].endDate
          );
        }
      }
      this.officeCodeList = [];
      this.hospitalCodeList = [];
      for (var j in this.data.carryingItems) {
        var office = this.data.carryingItems[j].officeCode;
        var hospitalCode = this.data.carryingItems[j].hospitalCode;
        var hospitalName = this.data.carryingItems[j].hospitalName;
        if (office) {
          var isExistence = this.officeCodeList.filter(
            val => val.code == office
          );
          if (isExistence.length == 0) {
            this.officeCodeList.push({ code: office });
          }
        }
        if (hospitalCode) {
          var isExistenceHospital = this.hospitalCodeList.filter(val => val.hospitalCode == hospitalCode);
          if (isExistenceHospital.length == 0) {
            this.hospitalCodeList.push({ hospitalCode: hospitalCode, hospitalName: hospitalName });
          }
        }
      }
      if (!this.data.inChargeOfficeCode && this.officeCodeList.length > 0) {
        this.data.inChargeOfficeCode = this.officeCodeList[0].code;
      }
      if (!this.data.hospitalName && this.hospitalCodeList.length == 1) {
        this.data.hospitalCode = this.hospitalCodeList[0].hospitalCode;
        this.data.hospitalName = this.hospitalCodeList[0].hospitalName;
      }
      this.CompSalesOfficeCode = this.data.officeCode;
    },
    getTravelInfoPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    checkIn: function(index, value) {
      this.data.hotelDetails[index].startDate = this.formatDate(value);
    },
    checkOut: function(index, value) {
      this.data.hotelDetails[index].endDate = this.formatDate(value);
    },
    getOfficeName: function(officeMaster, value) {
      var officeElement = officeMaster.find(v => v.officeCode === value);
      if (officeElement) {
        return officeElement.officeName;
      }
      return "";
    },
    inputCheckBox(productCode) {
      if (productCode) {
        // 機器にチェック
        var target = this.data.carryingItems.find(
          item => item.productCode == ""
        );
        if (target) {
          target.carrying = false;
        }
      } else {
        // 機器なしにチェック
        var targetList = this.data.carryingItems.filter(item => {
          return item.productCode != "";
        });
        for (var i = 0; i < targetList.length; i++) {
          targetList[i].carrying = false;
        }
      }
    },
    changeStaff: function(event) {
      // 旅程登録者変更
      this.isManagerChangeActive = true;
    },
    staffChanged: function(officeCode, officeName, staffCode, fullName,id,mobilePhoneNumber) {
      this.data.staffCode = staffCode;
      this.data.staffName = fullName;
      this.data.staffOfficeCode = officeCode;
      this.data.staffmobilePhoneNumber = mobilePhoneNumber;
      this.data.staffId = id;
    },
    inputTravelOffice: function(index) {
      // 依頼先営業所が変更された場合、「確認状況」「設置状況」はクリア
      // this.$set(this.data.hotelDetails[index],"requestFlag",false)
      this.$set(this.data.hotelDetails[index],"confirmationFlag",false)
      //this.$set(this.data.hotelDetails[index],"completeFlag",false)

      var isEditOffice = this.referenceEnableOfficeList.find(val => val.officeCode == this.data.hotelDetails[index].officeCode)
      if(isEditOffice){
        this.$set(this.data.hotelDetails[index],"targetSalesOfficeUserFlag",true)
      }else{
        this.$set(this.data.hotelDetails[index],"targetSalesOfficeUserFlag",false)
      }
    },
    inputRequestFlag: function(index) {
      // 設置依頼が変更された場合、「確認状況」「設置状況」はクリア
      this.$set(this.data.hotelDetails[index],"confirmationFlag",false)
      //this.$set(this.data.hotelDetails[index],"completeFlag",false)
    },
    displayStaffMobilePhoneNumber : function(PhoneNumber) {
      var display = ""
      if(PhoneNumber) {
        return display = "（携帯番号：" + PhoneNumber + "）";
      }
      return display
    }
  },
  data() {
    var data = {};
    var officeMaster = JSON.parse(sessionStorage.getItem("officeMaster"));
    var CompOfficeCodeUserInfo = JSON.parse(sessionStorage.getItem("userInfo")).officeCode;
    var CompSalesOfficeCode = "";
    var role = JSON.parse(sessionStorage.getItem("userInfo")).roleId;
    var referenceEnableOfficeList = JSON.parse(
      sessionStorage.getItem("referenceEnableOffice")
    );
    var type = this.$route.params["type"];
    var code = this.$route.params["domesticTravelCode"];
    var domesticTravelCodeRet = this.$route.params["domesticTravelCode"];
    var newStatus;
    var editFlg = this.$route.params["editFlg"];
    var officeCodeList = [];
    var hospitalCodeList = [];
    if (this.$route.params["status"]) {
      newStatus = this.$route.params["status"];
    } else {
      newStatus = 6;
    }
    var searchConditions = this.$route.params["searchConditions"];

    if (type === "edit" || type === "copy") {
      // データ取得
      var excuteApi = this.getTravelInfoPOST;
      var successCallBack = this.getTravelInfoPOSTSuccess;
      var errorCallBack = this.getTravelInfoPOSTError;
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    } else {
      var patientInfo = this.$route.params["patientInfo"];
      var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      var officeName = this.getOfficeName(officeMaster, userInfo.officeCode);
      var referenceOfficeCodes = userInfo.referenceOfficeCodes
      if(!referenceOfficeCodes.includes(userInfo.officeCode)){
        referenceOfficeCodes.push(userInfo.officeCode)
      }
      data = {
        startDate: "",
        endDate: "",
        hospitalName: "",
        hospitalPhone: "",
        travelAgentStaffName: "",
        travelAgentPhone: "",
        travelAgentStaffPhone: "",
        officeCode: userInfo.officeCode,
        officeName: officeName,
        staffId: userInfo.id,
        staffCode: userInfo.staffCode,
        staffName: userInfo.fullName,
        staffOfficeCode: userInfo.officeCode,
        staffmobilePhoneNumber: userInfo.mobilePhoneNumber,
        travelAgentName: "",
        carryingItems: [],
        hotelDetails: [{
          requestFlag:false
        }],
        status: newStatus
      };
      if (Object.keys(patientInfo).length != 0) {
        // 患者情報持っている場合
        data.patientCode = patientInfo.code;
        data.patientName = patientInfo.name;
        data.patientNameKana = patientInfo.kana;
        data.patientPhone = patientInfo.phone;
        data.carryingItems = [
          {
            productCode: "",
            serialNumber: "",
            productName: "持参機器無し",
            officeCode: "",
            carrying: false
          }
        ];
        if (patientInfo.productList.length != 0) {
          for (var i in patientInfo.productList) {
            if (patientInfo.productList[i].doctorName) {
              data.doctorName = patientInfo.productList[i].doctorName;
            }
            data.carryingItems.push({
              productCode: patientInfo.productList[i].productCode,
              productName: patientInfo.productList[i].productName,
              officeCode: patientInfo.productList[i].officeCode,
              hospitalCode:patientInfo.productList[i].hospitalCode,
              hospitalName:patientInfo.productList[i].hospitalName,
              carrying: true
            });
            var office = patientInfo.productList[i].officeCode;
            var hospitalCode = patientInfo.productList[i].hospitalCode;
            var hospitalName = patientInfo.productList[i].hospitalName;
            if (office.startsWith("J") || office.startsWith("C")) {
              office = office.substr(1);
            }
            var isExistence = officeCodeList.filter(val => val.code == office);
            if (isExistence.length == 0) {
              officeCodeList.push({ code: office });
            }
            var isExistenceHospital = hospitalCodeList.filter(val => val.hospitalCode == hospitalCode);
            if (isExistenceHospital.length == 0) {
              hospitalCodeList.push({ hospitalCode: hospitalCode, hospitalName: hospitalName });
            }
          }
          data.inChargeOfficeCode = officeCodeList[0].code;
          data.hospitalCode = hospitalCodeList.length == 1 ? hospitalCodeList[0].hospitalCode : "";
          data.hospitalName = hospitalCodeList.length == 1 ? hospitalCodeList[0].hospitalName : "";
        }
      }
    }
    return {
      data,
      officeMaster,
      status: newStatus,
      newStatus,
      type,
      code,
      startDate: null,
      endDate: null,
      hotelStartDate: [],
      hotelEndDate: [],
      isSelectPatientActive: false,
      bit: 0x000000,
      transportations,
      searchConditions,
      editFlg,
      isManagerChangeActive: false,
      officeCodeList,
      hospitalCodeList,
      referenceEnableOfficeList,
      domesticTravelCodeRet,
      CompOfficeCodeUserInfo,
      CompSalesOfficeCode,
      role
    };
  },
  components: {
    "selectPatient-form": SelectPatientForm,
    "staffChange-modal": StaffChangeModalForm
  },
  filters: {
    officeFilter: function(value, officeMaster, isPhoneFlg) {
      var officeElement = officeMaster.find(v => v.officeCode === value);
      if (officeElement) {
        return isPhoneFlg ? officeElement.officeName + " （営業所番号：" + officeElement.phoneNumber + "）" : officeElement.officeName;
      }
      return "";
    }
  },
  watch: {
    startDate(value) {
      this.data.startDate = this.formatDate(value);
    },
    endDate(value) {
      this.data.endDate = this.formatDate(value);
    }
  },
  created: function() {
    this.$validator.extend("hasCarring", {
      getMessage: field => `持参機器を選択してください。`,
      validate: () => {
        var carryingItems = this.data.carryingItems;
        var ret = false;
        for (var index in carryingItems) {
          if (carryingItems[index].carrying === "true") {
            carryingItems[index].carrying = true;
          }
          if (carryingItems[index].carrying === "false") {
            carryingItems[index].carrying = false;
          }
          if (carryingItems[index].carrying === true) {
            ret = true;
            break;
          }
        }
        return ret;
      }
    });
    this.$validator.extend("endDateCheck", {
      getMessage: field => `開始年月日以降の日付を選択してください。`,
      validate: endDate => {
        var ret = true;
        var startDate = this.startDate;
        if (startDate) {
          if (startDate > endDate) {
            ret = false;
          }
        }
        return ret;
      }
    });
    this.$validator.extend("checkoutDateCheck", {
      getMessage: field => `チェックイン年月日以降の日付を選択してください。`,
      validate: (checkoutDate, data) => {
        var ret = true;
        var checkinDate = this.parseDate(data[0]);
        if (checkinDate) {
          if (checkinDate > checkoutDate) {
            ret = false;
          }
        }
        return ret;
      }
    });
    this.$validator.extend("admissionDateCheck", {
      getMessage: field => `開始年月日以降の日付を選択してください。`,
      validate: checkinDate => {
        var ret = true;
        var startDate = this.startDate;
        if (startDate) {
          if (startDate > checkinDate) {
            ret = false;
          }
        }
        return ret;
      }
    });
    this.$validator.extend("exitDateCheck", {
      getMessage: field => `終了年月日以前の日付を選択してください。`,
      validate: checkoutDate => {
        var ret = true;
        var endDate = this.endDate;
        if (endDate) {
          if (checkoutDate > endDate) {
            ret = false;
          }
        }
        return ret;
      }
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AppDomesticTravel.vue